import React from 'react';
import { fmtDur } from '../lib/time.js';
import { Card } from './ui.jsx';

function pctOf(part, whole) {
  return `${whole ? Math.round((part / whole) * 100) : 0}% of work`;
}

function days(hours) {
  const count = Math.round((hours / 8) * 10) / 10;
  return `${count} day${count === 1 ? '' : 's'}`;
}

// The five hour boxes every total screen shares (Timesheet, My report,
// Reports), in one order and with one meaning: Total = client work + internal
// work + paid absence; unpaid absence sits beside it and is never counted.
// The bar under them draws the same sum, so how the total was made is on the
// screen rather than in a footnote.
export function HoursBreakdown({ hours, totalLabel = 'Total' }) {
  const { client, internal, paidAbsence, unpaidAbsence, work, total } = hours;
  return (
    <div className="hours-breakdown">
      <div className="stats stats-five">
        <Card className="stat-total">
          <span className="stat-label">{totalLabel}</span>
          <strong className="stat-value">{fmtDur(total)}</strong>
          <span className="stat-sub">
            {(total / 8).toFixed(2)} MD · work + paid absence
          </span>
        </Card>
        <Card>
          <span className="stat-label">
            <i className="hours-swatch is-client" aria-hidden="true" />
            Client work
          </span>
          <strong className="stat-value">{fmtDur(client)}</strong>
          <span className="stat-sub">{pctOf(client, work)}</span>
        </Card>
        <Card>
          <span className="stat-label">
            <i className="hours-swatch is-internal" aria-hidden="true" />
            Internal work
          </span>
          <strong className="stat-value">{fmtDur(internal)}</strong>
          <span className="stat-sub">{pctOf(internal, work)}</span>
        </Card>
        <Card>
          <span className="stat-label">
            <i className="hours-swatch is-paid-absence" aria-hidden="true" />
            Paid absence
          </span>
          <strong className="stat-value">{fmtDur(paidAbsence)}</strong>
          <span className="stat-sub">in total · {days(paidAbsence)}</span>
        </Card>
        <Card className="stat-unpaid">
          <span className="stat-label">
            <i className="hours-swatch is-unpaid-absence" aria-hidden="true" />
            Unpaid absence
          </span>
          <strong className="stat-value">{fmtDur(unpaidAbsence)}</strong>
          <span className="stat-sub">not in total · {days(unpaidAbsence)}</span>
        </Card>
      </div>
      {total + unpaidAbsence > 0 && (
        <div className="hours-bar-wrap">
          <div className="hours-bar" aria-hidden="true">
            <div className="hours-bar-total" style={{ flexGrow: total }}>
              {[
                ['is-client', client],
                ['is-internal', internal],
                ['is-paid-absence', paidAbsence],
              ]
                .filter(([, value]) => value > 0)
                .map(([tone, value]) => (
                  <span
                    key={tone}
                    className={`hours-swatch ${tone}`}
                    style={{ flexGrow: value }}
                  />
                ))}
            </div>
            {unpaidAbsence > 0 && (
              <span
                className="hours-swatch is-unpaid-absence"
                style={{ flexGrow: unpaidAbsence }}
              />
            )}
          </div>
          <p className="hours-bar-legend">
            <span>
              {totalLabel} {fmtDur(total)} = {fmtDur(client)} client work +{' '}
              {fmtDur(internal)} internal work + {fmtDur(paidAbsence)} paid
              absence
            </span>
            {unpaidAbsence > 0 && (
              <span>
                + {fmtDur(unpaidAbsence)} unpaid absence, not in total
              </span>
            )}
          </p>
        </div>
      )}
    </div>
  );
}
